import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { CountryPhone, COUNTRIES_PHONES_JSON_URL } from './phone-input.models';

/**
 * Servicio que carga y cachea la lista de países con códigos de marcación.
 * Responsabilidad única: proporcionar la lista de países con códigos de teléfono.
 */
@Injectable({ providedIn: 'root' })
export class CountriesPhoneService {
  private cache$: Observable<CountryPhone[]> | null = null;

  constructor(private http: HttpClient) {}

  /**
   * Devuelve la lista de países. La carga se hace una sola vez y se cachea en memoria.
   * En caso de error devuelve un array vacío.
   */
  getCountries(): Observable<CountryPhone[]> {
    if (!this.cache$) {
      this.cache$ = this.http
        .get<CountryPhone[]>(COUNTRIES_PHONES_JSON_URL)
        .pipe(
          shareReplay(1),
          catchError(() => of([])),
        );
    }
    return this.cache$;
  }
}